<script lang="ts">
  import { DecimalInput } from "$lib/components/ui/input";
  import { Label } from "$lib/components/ui/label";
  import * as Select from "$lib/components/ui/select/index.js";

  import {
    perforationTypes,
    supportsSecurityPerforation,
    type PerforationType,
    type SecurityPerforation,
  } from "@briefmarken_katalog/types"
  import { t } from "$lib/i18n";
  import SecurityPerforationEditor from "./SecurityPerforationEditor.svelte";

  let { horizontal = $bindable(), vertical = $bindable(), type = $bindable(), security = $bindable(), isReadonly = false }: { horizontal: number, vertical: number, type: PerforationType | undefined, security: SecurityPerforation | undefined, isReadonly?: boolean } = $props();

  const triggerValue_PerforationType = $derived(
    type ? $t(`fields.perforationTypeLabels.${type}`) : $t('fields.selectType')
  );

  /** Only a line or comb perforation has a hole row that can carry special holes. */
  const allowsSecurity = $derived(supportsSecurityPerforation(type));

  // Switching to a type without a hole row drops the special holes rather than keeping
  // them around invisibly until the next save.
  $effect(() => {
    if (!isReadonly && !allowsSecurity && security !== undefined) security = undefined;
  });
</script>

<div class="grid grid-cols-4 items-center gap-4">
  <Label for="perforation" class="text-right">{$t('fields.perforation')}</Label>
  <div id="perforation" class="flex gap-2 col-span-3">

{#if isReadonly}
        <div class="p-2 border rounded">{type ? $t(`fields.perforationTypeLabels.${type}`) : ''}</div>
{:else}
    <Select.Root type="single" name="type" bind:value={type}>
      <Select.Trigger class="w-[180px]">
        {triggerValue_PerforationType}
      </Select.Trigger>
      <Select.Content>
        <Select.Group>
          <Select.Label>{$t('fields.perforationType')}</Select.Label>
          {#each perforationTypes as type}
            <Select.Item
              value={type}
              label={$t(`fields.perforationTypeLabels.${type}`)}
              >
              {$t(`fields.perforationTypeLabels.${type}`)}
            </Select.Item>
          {/each}
        </Select.Group>
      </Select.Content>
    </Select.Root>
{/if}
    <Label for="horizontal" class="text-right">{$t('fields.horizontal')}</Label>
    <DecimalInput readonly={isReadonly} disabled={type === 'Imperforated'} id="horizontal" bind:value={horizontal} placeholder="0" class="w-24" />
    <Label for="vertical" class="text-right">{$t('fields.vertical')}</Label>
    <DecimalInput readonly={isReadonly} disabled={type === 'Imperforated'} id="vertical" bind:value={vertical} placeholder="0" class="w-24" />
  </div>
</div>
{#if isReadonly}
  <SecurityPerforationEditor security={security} isReadonly />
{:else if allowsSecurity}
  <!-- Its own row: the perforation row is already full at the dialog's width. -->
  <div class="grid grid-cols-4 items-center gap-4">
    <div></div>
    <div class="col-span-3">
      <SecurityPerforationEditor bind:security />
    </div>
  </div>
{/if}
